import LegalPageLayout from './LegalPageLayout'
import { contactWhatsAppUrl, youtubeChannelUrl } from './siteDestinations'

export default function NotFoundPage() {
  return (
    <LegalPageLayout eyebrow="Endereço não encontrado" title="Essa página não existe." showUpdated={false}>
      <p className="legal-page__intro">
        O endereço que você abriu não corresponde a nenhuma página da Oficina IA. Pode ter mudado
        ou ter sido digitado de um jeito diferente.
      </p>

      <section aria-labelledby="not-found-next">
        <h2 id="not-found-next">Por onde continuar</h2>
        <p>
          <a className="button button--primary" href="/">Ir para a página inicial</a>
        </p>
        <p>
          Se preferir, <a href={youtubeChannelUrl} target="_blank" rel="noopener noreferrer">abra o canal da Oficina IA no YouTube</a>{' '}
          ou <a href={contactWhatsAppUrl} target="_blank" rel="noopener noreferrer">fale comigo no WhatsApp</a>.
        </p>
      </section>
    </LegalPageLayout>
  )
}
